import React from 'react';
import { shallow, ShallowWrapper } from 'enzyme';
import MismatchToInProgressModalContainer from './MismatchToInProcessModalContainer';

const createProps = () => ({ modalRef: '' });

let props;
let wrapped: ShallowWrapper;

describe('Your description here', () => {
  beforeEach(() => {
    props = createProps();
    wrapped = shallow(<MismatchToInProgressModalContainer {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
